/** ****************************************************************************
		███╗   ██╗███████╗██████╗  █████╗  ██████╗
		████╗  ██║██╔════╝██╔══██╗██╔══██╗██╔═══██╗
		██╔██╗ ██║█████╗  ██║  ██║███████║██║   ██║
		██║╚██╗██║██╔══╝  ██║  ██║██╔══██║██║   ██║
		██║ ╚████║███████╗██████╔╝██║  ██║╚██████╔╝
		╚═╝  ╚═══╝╚══════╝╚═════╝ ╚═╝  ╚═╝ ╚═════╝

@description Affichage en deux tabs des prix membre/partenaire.

@author Victor Audetat <audetat.v@gmail.com>

@copyright © 2020  NEDAO Association (info@nedao.ch)
@see {@link https://association.nedao.ch}

@license
	This program is free software: you can redistribute it and/or modify
	it under the terms of the GNU Affero General Public License as published
	by the Free Software Foundation, either version 3 of the License, or
	(at your option) any later version.

	This program is distributed in the hope that it will be useful,
	but WITHOUT ANY WARRANTY; without even the implied warranty of
	MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
	GNU Affero General Public License for more details.

	You should have received a copy of the GNU Affero General Public License
	along with this program.  If not, see <https://www.gnu.org/licenses/>.
*******************************************************************************/

import React, { useState } from "react";
import {LeanButton} from "nedao-branding";
import MailTo from "../MailTo";
import "./pricing-table.scss";


const PricingTable = () => {
	const [state, setState] = useState("membre");

	const content = {
		membre: {
			bulletPoint: [
				"Cotisation membre particulier: 50 CHF/an",
				"Cotisation membre entreprise: 200 - 500 CHF/an (dépendant du nombre d'employés)",
				"Cotisation membre associatif: 100 CHF/an",
				"Cotisation membre académique ou collectivité publique: sur demande"
			],
			description:
        "Soutenez l'Association en devenant membre actif. Participez aux Assemblées Générales et apportez votre pierre à l'édifice!",
		},
		partenaire: {
			bulletPoint: [
				"Apportez un financement, ou mettez simplement vos resources ou votre force de travail à disposition",
				"Organisez des events autour du projet",
				"Votre logo sur tous nos supports de communication"
			],
			description:
        "Supportez activement le développement du projet NEDAO et/ou ses projets associés, sa promotion, et/ou son adoption et intégration.",
		},
	};

	const style = {
		span: {
			marginLeft: state === "membre" ? 0 : "50%",
		},
	};

	return (
		<section className="pricing-table__section">
			<h2>Soutenir l&#39;association NEDAO</h2>
			<div className="pricing-table__tabs">
				<button
					style={{
						backgroundColor: state === "partenaire" ? "#fff" : "#fff3f2",
					}}
					onClick={() => setState("membre")}>
                    Membre
				</button>
				<button
					style={{
						backgroundColor: state === "membre" ? "#fff" : "#fff3f2",
					}}
					onClick={() => setState("partenaire")}>                    
                    Partenaire
				</button>
				<span style={style.span} />
			</div>
			<div className="pricing-table__container">
				<p>{content[`${state}`].description}</p>
				<ul>
					{content[`${state}`].bulletPoint.map((point, index) => (
						<li key={index}>{point}</li>
					))}
				</ul>
				<MailTo
					subject={
						state === "membre"
							? "Demande d'adhésion membre NEDAO ASSOCIATION"
							: "Demande de partenariat NEDAO ASSOCIATION"
					}
				>
					<LeanButton 
						text={`Devenir ${state}`}
						isImportant={true}
					/>
				</MailTo>
			</div>
		</section>
	);
};


export default PricingTable;
